require('./overrides.scss')

export default {
  theme: {
    themes: {
      light: {
        primary: '#ffb400',
        accent: '#0073e6',
        secondary: '#8A8D93',
        success: '#56CA00',
        info: '#16B1FF',
        warning: '#FFB400',
        error: '#FF4C51',
      },
      dark: {
        primary: '#ffb400',
        accent: '#0073e6',
        secondary: '#8A8D93',
        success: '#56CA00',
        info: '#16B1FF',
        warning: '#FFB400',
        error: '#FF4C51',
      },
    },
  },
}
